export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{ title: 'device_profile', component: 'pro3em_profile' },
		{
			title: 'reverse_measurement_direction',
			component: 'reverse_measurement_direction_monophase',
		},
		{ title: 'delete_stored_data', component: 'delete_stored_data_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
